import React, { memo/*, useEffect*/ } from "react";
import { ContenedorVertical, ItemLabel } from './Filtro.styles'

// const getFontSizes = size => {
//     switch (size) {
//         case 'md':
//             return '12px';
//         case 'lg':
//             return '12px';
//         case 'xl':
//             return '12px';
//         default:
//             return '12px';
//     }
// }

const Filtro = ({ children, label, /*size = 'md',*/ justifyClass ="text-left", className = "" }) => {

    // useEffect(() => console.log("Render - Filtro"));
    // const labelFontSize = getFontSizes(size);

    return <ContenedorVertical className={className}>
        <ItemLabel className={justifyClass}>
            {label}
        </ItemLabel>
        {children}
    </ContenedorVertical>
}

export default memo(Filtro);